<template>
  <li
    class="flex items-center flex-col"
  >
    <stormy-peer-checkbox
      :id="`media-${mid}`"
      v-model="selectedItems"
      :name="`media-${mid}`"
      :true-value="mid"
    />

    <label
      ref="wrapper"
      :for="`media-${mid}`"
      class="flex flex-col items-center  justify-between w-full  text-gray-500 border-gray-200 rounded-md   hover:text-gray-600 peer-checked:ring-2  peer-checked:ring-blue-500  peer-checked:ring-offset-2 peer-checked:text-gray-600 hover:bg-gray-50"
      :class="isDisabled ? 'cursor-not-allowed bg-gray-50/50' : 'cursor-pointer'"
    >
      <MediaLazyImage
        :is-new="isNew"
        class="aspect-[4/3] rounded-md object-cover h-full"
        :src="source"
        :blurhash="blurhash"
        :width="width"
        :height="height"
        :alt="title"
      />
    </label>
    <p class="pointer-events-none mt-2 w-full block truncate text-sm font-medium text-center text-gray-900">
      {{ filename }}
    </p>
  </li>
</template>
<script setup>
import { computed, ref, toRefs } from 'vue'
import { useProp } from '@/composables/useProp.js'
import MediaLazyImage from './MediaLazyImage.vue'
import { useTemplateFilter } from '@/composables/useTemplateFilter.js'
import { useMediaStore } from '@/pinia/MediaStore'
import { storeToRefs } from 'pinia'

const mediaStore = useMediaStore()
const { selectedItems } = storeToRefs(mediaStore)

const { formatBytes } = useTemplateFilter()

const props = defineProps({
  file: useProp(Object),
  mid: useProp(Number),
  currentId: useProp(Number),
  newFileIds: useProp(Array),
  multiple: useProp(Boolean, false),
  isDisabled: useProp(Boolean, false)
})

const emit = defineEmits(['select'])

const currentFile = computed(() => props.mid === props.currentId)

const { file } = toRefs(props)

const wrapper = ref()
const isNew = computed(() => props.newFileIds.includes(props.mid))

const thumbnail = computed(() => file.value?.file?.breakpoints?.thumbnail || null)

const size = computed(() => formatBytes(file.value.file.size))
const filename = computed(() => file.value.org_name)
const title = computed(() => file.value.title)
const source = computed(() => file.value?.base_url || null)
const blurhash = computed(() => file.value.blurhash || 'null')

const width = computed(() => wrapper.value?.clientWidth)
const height = computed(() => wrapper.value?.clientHeight)

</script>
